export const foundationShadowTokens = {
  sm: 'shadow-sm',
  card: 'shadow-card',
  cardHover: 'hover:shadow-card-hover',
  floating: 'shadow-lg'
} as const;